import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api, errMsg } from "../lib/api";

export const ForgotPasswordForm = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setMsg(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="w-full max-w-sm bg-surface border border-line p-8 rise" data-testid="forgot-form">
      <h2 className="font-display text-3xl font-bold tracking-tight">Forgot password</h2>
      <p className="text-sm text-muted-c mt-1 mb-6">Enter your login email and we'll send you a reset link.</p>
      <div className="mb-4">
        <Label htmlFor="forgot-email">Email</Label>
        <Input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-none" data-testid="forgot-email-input" />
      </div>
      {msg && <p className="text-sm text-pos mb-3" data-testid="forgot-success">{msg}</p>}
      {error && <p className="text-sm text-neg mb-3" data-testid="forgot-error">{error}</p>}
      <Button type="submit" disabled={busy} className="w-full rounded-none bg-brand hover:bg-brand/90 text-onbrand" data-testid="forgot-submit-button">
        {busy ? "Sending…" : "Send reset link"}
      </Button>
      <button type="button" onClick={onBack} className="mt-4 text-sm text-brand hover:underline w-full text-center" data-testid="back-to-login-button">
        Back to sign in
      </button>
    </form>
  );
};
